import { render, staticRenderFns } from "./InvoicesNovaPoshtaTable.vue?vue&type=template&id=56840ec6&scoped=true"
import script from "./InvoicesNovaPoshtaTable.vue?vue&type=script&lang=js"
export * from "./InvoicesNovaPoshtaTable.vue?vue&type=script&lang=js"
import style0 from "./InvoicesNovaPoshtaTable.vue?vue&type=style&index=0&id=56840ec6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56840ec6",
  null
  
)

export default component.exports